import { render, staticRenderFns } from "./ResumeContent.vue?vue&type=template&id=2d51085a&"
import script from "./ResumeContent.vue?vue&type=script&lang=js&"
export * from "./ResumeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports